import React from "react";
import GoogleButton from "react-google-button";

import classes from "./GoogleButton.module.css";

const googleButton = ({ clicked }) => (
  <GoogleButton
    onClick={clicked}
    type="light"
    className={classes.GoogleButton}
  />
);

export default googleButton;
